const utils = {
  /**
   * isEmpty will return true if the value is undefined, null, 
      or has a length of zero (for strings, arrays, or objects)
   * @returns {boolean} True is Empty and false if non empty value.
   */
  isEmpty: (value) => {
    if (value === undefined || value === null) {
      return true;
    }
    if (typeof value === "string" || Array.isArray(value)) {
      return value.length === 0;
    }
    if (typeof value === "object") {
      return Object.keys(value).length === 0;
    }
    return false;
  },
};

export default utils;
